<template>
    <div class="filterWrap">
        <dl>
            <dt>地区：</dt>
            <dd v-if="areaList.length">
                <template v-for="(item,i) in areaList">
                    <a :title="item.title" href="javaScript:void(0);" :key="i" @click="gotoMore(item,1)">{{item.name}}</a>
                </template>
            </dd>
        </dl>
        <dl>
            <dt>省市：</dt>
            <dd v-if="cityList.length">
                <template v-for="(item,i) in cityList">
                    <a :key="i" :title="item.title" href="javaScript:void(0);" @click="gotoMore(item,2)">{{item.name}}</a>
                </template>
                <router-link :to="{path:'/mechanismsearch'}" class="all" v-if="$route.path != '/mechanismsearch'">更多&gt;&gt;</router-link>
            </dd>
        </dl>
        <dl>
            <dt>业务：</dt>
            <dd v-if="classList.length">
                <template v-for="(item,i) in classList">
                    <a :title="item.title" href="javaScript:void(0);" :key="i" @click="gotoMore(item,3)">{{item.name}}</a>
                </template>
            </dd>
        </dl>
        <dl class="letter">
            <dt>字母：</dt>
            <dd v-if="letterList.length">
                <template v-for="(item,i) in letterList">
                    <a :title="item.title" href="javaScript:void(0);" :key="i" @click="gotoMore(item,4)">{{item.name}}</a>
                </template>
            </dd> 
        </dl>
        <div class="fix">
            <div class="search inSearch" id="minSearch">
                <div id="sForm" class="">
                    <span @click="sensors(selVal)">
                        <router-link :to="{path:'/mechanismsearch?name='+selVal}" class="sbtn">搜索</router-link>
                    </span>
                    <div class="sRadius">
                        <input type="text" id="keywordes" name="keywordes" class="sInput sGray" placeholder="请输入机构名称" v-model="selVal">
                    </div>
                </div>
            </div>
            <div class="criteria fix fl" v-if="$route.query.area_name || $route.query.province || $route.query.class_name || $route.query.letter">
                <strong class="crTxt fl">已选条件：</strong>
                <ul class="crUl fl">
                    <li v-if="$route.query.area_name">
                        <span>地区：</span>
                        <strong>{{$route.query.area_name}}</strong>
                        <a href="javaScript:;" @click="clearData(1)"></a>
                    </li>
                    <li v-if="$route.query.province">
                        <span>省市：</span>
                        <strong>{{$route.query.province}}</strong>
                        <a href="javaScript:;" @click="clearData(2)"></a>
                    </li>
                    <li v-if="$route.query.class_name">
                        <span>业务：</span>
                        <strong>{{$route.query.class_name}}</strong>
                        <a href="javaScript:;" @click="clearData(3)"></a>
                    </li>
                    <li v-if="$route.query.letter">
                        <span>字母：</span>
                        <strong>{{$route.query.letter}}</strong>
                        <a href="javaScript:;" @click="clearData(4)"></a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { sentSensors } from '@/utils/buriedPoint.js'
export default {
    name: "filter",
    props:{
        areaList:{
            type:Array
        },
        cityList:{
            type:Array
        },
        classList:{
            type:Array
        },
        letterList:{
            type:Array
        },
    },
    data(){
        return{
            selVal:'',
            queryCode :{
                area_name:this.$route.query.area_name || '',
                province:this.$route.query.province || '',
                class_name:this.$route.query.class_name || '',
                letter:this.$route.query.letter || '',
                name:this.$route.query.name || ''
            }
        }
    },
    methods:{
        sensors(content) {
            // 神策埋点
            sentSensors('拍卖黄页',content)
        },
        gotoMore(item,num){
            switch (num){
                case 1:
                    this.queryCode.area_name = item.name
                    break
                case 2:
                    this.queryCode.province = item.name
                    break
                case 3:
                    this.queryCode.class_name = item.name
                    break
                case 4:
                    this.queryCode.letter = item.name
                    break
            }
            this.$router.push({
                path:'/mechanismsearch',
                query:this.queryCode
            })

        },
        clearData(num){
            switch (num) {
                case 1:
                    this.queryCode.area_name = ''
                    break
                case 2:
                    this.queryCode.province = ''
                    break
                case 3:
                    this.queryCode.class_name = ''
                    break
                case 4:
                    this.queryCode.letter = ''
                    break
            }
            this.$router.push({
                path:'/mechanismsearch',
                query:this.queryCode
            })
        }
    }
}
</script>

<style scoped lang="scss">
.filterWrap{background:#FFF; font-size:12px; padding:8px 10px 15px;}
.filterWrap dl{ line-height:26px; padding-bottom:1px;font-family: Simsun}
.filterWrap dt{float:left;_display:inline; width:48px;color:#666666; font-weight:bold;}
.filterWrap dd{padding-left:48px;}
.filterWrap dd a{margin-right:20px;}
.filterWrap dd a:hover{ background:#0F820C; color:#FEFEFE;}
.letter dd{ font-family:Verdana,'SimSun'}
.recAgency{width:994px; margin:0 auto;}
.recAgency .bdtit{margin:0px 7px; }
.recAgency .bdtit .titName{ float:left;}
.recAgency .nobgTab{ padding-left:3px;}
.recAgency .nobgTab li{ border-left:1px solid #ccc; border-right:0px; cursor:pointer}
.recAgency .nobgTab .first{ border-left:none;}
.recAgency .tabs{background:url(../../../assets/imgs/old/dashed.png) 0px 100% repeat-x; }
.recAgency .BotTabs{background:url(../../../assets/imgs/old/dashed.png) 0px 0px repeat-x; padding-top: 1px;margin:0px 4px;}
.recAgency .BotTabs ul{ text-align: center;background:url(../../../assets/imgs/old/bg.png) 0px 0px repeat; padding:3px 0px 5px;*padding:13px 0px; overflow: hidden;}
.recAgency .BotTabs li{ display: inline-block;*display:inline;*zoom:1; float: none; }


.recAgency .tabsCon{ padding:10px 0px;*zoom:1; height: 240px;}
.recAgency .tabsCon ul{*zoom:1; position:relative; }
.recAgency .tabsCon:after,.recAgency .tabsCon ul:after{clear:both;content:" ";display:block;font-size:0;height:0;line-height:0;visibility:hidden}
.recAgency .tabsCon li{padding-left: 7px; width: 75px; float: left;_display:inline; margin-top: 10px;}
.recAgency .tabsCon .tit{ background:url(../../../assets/imgs/old/bg.png) 0px 0px repeat;  color:#000; height:40px;padding-left:10px; width:68px; margin-left:4px; font:bold 14px/40px 'Microsoft Yahei'}
.recAgency .base{width: 75px; overflow: hidden;}
.recAgency .base a{display: block;}
.recAgency .base strong{display: block; text-align: center; font-size:12px;}
.recAgency .hover .base strong{ background: #0F820C;color: #FEFEFE; }
.recAgency .expand{position: absolute; top: 10px; left: 7px;z-index:1; visibility: hidden; width:977px; }
.recAgency  .hover .expand{ visibility:visible;}
.recAgency .expandWrap{float:left;border:3px solid #0F820C; width:971px;_zoom:1;background:#FFF;}
.recAgency .expandWrap .link{ float:left;width:200px; height:34px; overflow:hidden; }
.recAgency .expandBg{ position:relative;float:left;width:771px;height:34px; background:#FFF;overflow: hidden;}
.recAgency .brandLink,.recAgency .ident,.recAgency .ps,.recAgency .btnArea{float: left; }
.recAgency .brandLink{width:64px;height:34px; overflow:hidden; display:block;}
.recAgency .ident{padding:3px 9px 0 30px;  background:#FFF; width:216px;}
.recAgency .ident b{ float: left; display: inline-block; background-image:url(../../../assets/imgs/old/ident.png);background-repeat:no-repeat;height:27px; margin-right:30px;text-indent: -299px; overflow: hidden;}
.recAgency .ident .v{width: 37px; background-position: 0px 0px;}
.recAgency .ident .gy{width: 13px; background-position: -41px 0px;}
.recAgency .ident .db{width: 19px; background-position: -58px 0px;}
.recAgency .ident .file{width: 27px; background-position: -81px 0px;}
.recAgency .ps{ width:250px; height: 34px; overflow: hidden; border-left: 1px solid #d4d4d4; width: 250px;}
.recAgency .ps dt{ line-height: 34px; float: left;padding-left: 35px; font-family: 'Microsoft Yahei'; padding-right:15px;}
.recAgency .ps dd{ line-height: 16px; font-size: 12px;color:#666666; padding-top:2px;}
.recAgency .ps dd .noInfo{color:#666666; line-height:34px; font-weight:normal}
.recAgency .btnArea{float: right;overflow: hidden; width: 162px;background: #ffffff;}
.recAgency .btnArea .btn,.recAgency .disOpen{float: left; width: 80px; height: 34px;padding: 0px;  margin-left:1px;color: #FEFEFE; text-align: center;font:bold 14px/34px 'Microsoft Yahei';  }
.recAgency .disOpen{ color:#999;line-height:16px; text-align:center; width:79px; height:32px; border-left: 1px solid #d4d4d4;}
.recAgency .disOpen strong{color:#0F820C; cursor:pointer; font-weight:bold;}
.recAgency .disOpen .hover{ text-decoration:underline;}

.linkList{padding:13px 0px  15px 20px ; overflow: hidden;_zoom:1; height:173px; }
.linkList li{width: 140px; float: left;_display:inline; line-height: 24px; height: 24px; overflow: hidden;}
.linkList li a{ line-height: 1; font-size: 12px;padding:2px 0px;}
.linkList li span{ color: #999999; font-family:Verdana}
.linkList li a:hover,.linkList a:hover span{ background: #0F820C;color: #FEFEFE;}

.auctAgency .bdtit{position:relative;}
.auctAgency .titName{ float:left;}
.recAuctList,.allAuctShow ul{ overflow: hidden;_zoom:1;padding-left:10px;}
.showList{background:url(../../../assets/imgs/old/dot.png) 0px 16px no-repeat; }
.recAuctList li,.allAuctShow li{ float:left;_display:inline;width: 94px; height: 32px; overflow: hidden; font:14px/32px Arial, 'Microsoft Yahei'; word-break:break-all}
.recAuctList{background:url(../../../assets/imgs/old/dashed.png) 0px 100% repeat-x; padding:9px 0px 12px; height:128px;}
.recAuctList li{font-weight:bold;}

.city{float:left; }
.cityChoose{ padding:2px 10px 3px;cursor:pointer;  font-size:14px; float:left; font-family:'Microsoft Yahei';}
.cityChoose b{ display:inline-block;font-size:14px;  _margin-top:15px; vertical-align:middle; margin-left:5px; background:url(../../../assets/imgs/old/fold.png) 0px 0px no-repeat;width:7px;height:5px;cursor:pointer;}
.auctAgency .bdtit .hover .cityChoose{background:#0F820C; color:#FEFEFE;}
.auctAgency .bdtit .hover b{background-position:0px -10px;}
.cityWrap{ display:none; position:absolute; top:35px; left:0px; width:384px; height:344px; background:#FFFFFF; border:3px solid #0F820C;font-size:12px; padding-top:10px;}
.cityWrap dl{ padding:10px 0px;}
.cityWrap dt{  float:left;_display:inline;  font-weight:bold;width:74px; padding-right:20px; text-align:right; color:#999999; line-height:14px; height:14px; overflow:hidden; border-right:1px solid #dcdcdc}
.cityWrap dd{margin-left:95px; line-height:1;}
.cityWrap a,.cityWrap span{margin-left:20px;}
.cityWrap a:hover{background:#0F820C;color:#FEFEFE;}
.cityWrap span{color:#999999;}
.auctAgency .hover .cityWrap{ display:block;}

.allAuct{overflow: hidden;}
.allAuctShow{margin:9px 0px 12px; height: 128px; overflow: hidden;}
.allAuctShow a{ color: #666666;}
.allAuctShow a:hover{color:#0F820C}

.letterFilt{ overflow: hidden;padding-top: 20px; width: 395px; margin-left: -5px;}
.letterFilt li{ float: left;_display:inline; padding: 0px 10px;margin-right: 5px;background:url(../../../assets/imgs/old/bg.png) 0px 0px repeat;font:14px/22px Verdana;  color: #666666; cursor:pointer}
.letterFilt li.dis{ color:#999999; cursor:default;}
.letterFilt .curr{background: #000; color: #FEFEFE}

.auctSwitch{overflow: hidden;}
.auctSwitch li{float: left;_display:inline; width:195px; height: 16px; overflow: hidden; }
.auctSwitch a{display:block;width:195px; height: 16px;background-image: url(../../../assets/imgs/old/arrow_btn.png); background-repeat: no-repeat;}
.auctSwitch .prev{background-position: 0 0;}
.auctSwitch .prev:hover{background-position: 0 -21px;}
.auctSwitch .next{background-position: -196px 0;}
.auctSwitch .next:hover{background-position: -196px -21px;}
.auctSwitch .dis .prev,.auctSwitch .dis .prev:hover{background-position: 0 -42px; cursor: default;}
.auctSwitch .dis .next,.auctSwitch .dis .next:hover{background-position: -196px -42px;cursor: default;}
.brandWrap{padding:10px;}
.brandWrap .brand{background: #FFFFFF; font-size: 12px; line-height: 24px; height: 338px;overflow: hidden;}
.brandWrap h3{font-size: 12px; padding:14px 10px 0px; height:24px; overflow:hidden;}
.brand .subInfo{color:#666666;padding:0px 10px ; height:195px; overflow:hidden;}

.member dl{padding:15px 0px;background:url(../../../assets/imgs/old/dashed_gray.png) 0px 100% repeat-x; }
.member .last{background:none}
.member dt{ float:left;_display:inline;font:18px/22px 'Microsoft Yahei'; width: 82px; height: 54px; padding-left: 10px; padding-top:10px; color:#666666;background:url(../../../assets/imgs/old/bg.png) 0px 0px repeat;}
.member dt span{ font-family: Verdana;  display: block;color:#999999;font-size: 12px;}
.member dd{margin-left: 102px; overflow:hidden;font-size: 12px;}
.member .areaWrap{margin-right: 79px; height: 64px; overflow:hidden;}
.member .areaWrap li{overflow: hidden;_zoom:1;}
.member .areaWrap .odd{background:#f9f9f9; }
.member .areaWrap .hover{background:#f2f2f2; }
.member .areaWrap span{float:left;_display:inline;padding-left: 20px; width: 78px; line-height: 32px; }
.member .fold{float: right; width: 64px; height: 64px;background:url(../../../assets/imgs/old/bg.png) 0px 0px repeat; }
.member .open,.member .close{display:block;width: 42px; height: 53px;padding-top:11px; padding-left:22px; cursor:pointer;}
.member .open b,.member .close b{ display: block; background-image:url(../../../assets/imgs/old/fold.png);background-repeat:no-repeat;width:7px;height:5px;cursor:pointer; margin-left: 8px; overflow:hidden;}
.member .open b{background-position:0px 0px;}
.member .hover .open {background: #0F820C;color: #FEFEFE;}
.member .hover .open b{background-position:0px -10px; }
.member .nobgTab li{ border-left:1px solid #ccc; border-right:0px; cursor:pointer }
.member .nobgTab .first{ border-left:none; padding-left:0px;}

.member .close b{background-position:-17px 0px;}
.member .hover .close{background: #0F820C;color: #FEFEFE;}
.member .hover .close b{background-position:-17px -10px; }
.inSearch{padding:0px;margin:12px 0px 0px;width:auto;float:left;}
.inSearch #sForm{width:267px;height:30px;margin-right:0px; float:none}
.inSearch .sbtn{width:70px;height:30px;background:#0F820C;margin-left:0px;font-family:"Microsoft Yahei";color:#FEFEFE;text-indent:0px;text-align:center;font-weight:bold;line-height:30px}
.inSearch .sbtn:hover{background:#329D15;color:#FEFEFE}
.inSearch .sRadius{width:196px;margin:0px;border:1px solid #D4D4D4;border-right:0;border-radius:0px;padding:0px;line-height:20px;font-size:12px}
.inSearch .on .sRadius{border-color:#0F820C}
.inSearch .sInput{width:176px;height:20px;background-image:none!important;padding:4px 10px;font-size:12px!important;line-height:20px;}
.inSearch li{font-size:12px}
.criteria .crTxt {
    color: #666666;
    font-size: 14px;
    font-weight: bold;
    font-size: 12px;
}
.crUl{float:left;}
.criteria .crUl li {
    border: 1px solid #d4d4d4;
    height: 28px;
    line-height: 28px;
    padding: 0px 9px;
    float: left;
    margin-right: 10px;
}
.criteria .crUl li span {
    color: #999;
    display: inline-block;
    float: left;
}
.criteria .crUl li strong {
    color: #0F820C;
    font-weight: bold;
    display: inline-block;
    float: left;
}
.criteria .crUl li a {
    background: url(../../../assets/imgs/old/but.png) no-repeat left -180px;
    width: 12px;
    height: 12px;
    float: left;
    display: inline-block;
    margin: 8px 0 0 10px;
}
.criteria{margin-top: 12px;margin-left: 10px;}
.criteria .crUl li:hover{
    background: #0F820C;
    border: 1px solid #0F820C;
}
.criteria .crUl li:hover span, .criteria .crUl li:hover strong {
    color: #fff;
}
.criteria .crUl li:hover a {
    background: url(../../../assets/imgs/old/but.png) no-repeat left -202px;
}
</style>